import {combineReducers} from 'redux';
import SessionReducer from './reducer_session';
import SiteReducer from './reducer_site';
import ServiceUrlReducer from './reducer_serviceUrl';
import ExperimentsReducer from './reducer_experiments';
import TicketReducer from './reducer_ticket';
import LandingPageReducer from './reducer_landingPage';
import IsLegacyReducer from './reducer_isLegacy';
import IsOwnerReducer from './reducer_isOwner';

/**
 * Connect reducers to the redux store.
 */

/* istanbul ignore next */
const reducers = combineReducers({
    session: SessionReducer,
    site: SiteReducer,
    serviceUrl: ServiceUrlReducer,
    experiments: ExperimentsReducer,
    ticket: TicketReducer,
    landingPage: LandingPageReducer,
    isLegacy: IsLegacyReducer,
    isOwner: IsOwnerReducer
});

export default reducers;
